// Slovenské dvojče locale/cs/searchSuggest.js. Vlastní vyhledávání na SK zatím
// neběží (#71) — fráze jsou rozumný odhad, ne ověřená data z logu.
// SK: neověřeno ve fixtures (dotazy nejsou platformní text, jen kurátorský tip)
export default {
  popular: ['píla', 'krovinorez', 'kompresor', 'zváračka', 'ohrievač', 'rebrík', 'vysokotlakový čistič'],
};
